<template>
  <v-app>
    <LoadingWidget v-if="loading" />

    <template v-else>
      <HeaderShell />
      <NavigationWidget />

      <v-main>
        <router-view v-bind="$route.meta" />
      </v-main>

      <FooterShell />
    </template>

    <CookieBannerWidget />
    <GalleryWidget />
    <WhatsAppButtonWidget
      v-if="informations.whatsapp_float"
      :link="informations.whatsapp_float"
    />
  </v-app>
</template>

<script>
import HeaderShell from "./components/shell/header/HeaderShell.vue";
import FooterShell from "./components/shell/FooterShell.vue";
import CookieBannerWidget from "./components/widgets/CookieBannerWidget.vue";
import LoadingWidget from "./components/widgets/LoadingWidget.vue";
import GalleryWidget from "./components/widgets/GalleryWidget.vue";
import NavigationWidget from "./components/widgets/NavigationWidget.vue";
import WhatsAppButtonWidget from "./components/widgets/WhatsAppButtonWidget.vue";

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    name() {
      return this.informations.name || "";
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    updateDocumentTitle() {
      if (this.name && this.$route.name) {
        document.title = `${this.$route.name} | ${this.name}`;
      } else if (this.name && !this.$route.name) {
        document.title = this.name;
      } else if (!this.name && this.$route.name) {
        document.title = this.$route.name;
      } else {
        document.title = "";
      }
    },
  },
  watch: {
    $route() {
      this.updateDocumentTitle();
    },
    name() {
      this.updateDocumentTitle();
    },
  },
  created() {
    this.updateDocumentTitle();

    const informations = this.$rest("informations").get({
      save: (state, data) => (state.item = data),
    });

    const links = this.$rest("external-links").get({
      save: (state, data) => (state.item = data),
    });

    Promise.all([informations, links]).finally(() => (this.loading = false));
  },
  components: {
    HeaderShell,
    FooterShell,
    CookieBannerWidget,
    LoadingWidget,
    GalleryWidget,
    NavigationWidget,
    WhatsAppButtonWidget,
  },
};
</script>
